import { DashboardAppWebComponent } from './component/DashboardAppWebComponent';
import { WEB_COMPONENT_DASHBOARD_APP } from '../webcomponents.constants';

window.customElements.define(WEB_COMPONENT_DASHBOARD_APP, DashboardAppWebComponent);

export { DashboardAppWebComponent };
